import { Terminal } from 'lucide-react'
import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'

export const HeaderBrandLogo = forwardRef(function HeaderBrandLogo(
  { as: Component = 'span', ...props },
  ref,
) {
  return (
    <Component
      className="grid place-items-center min-h-10 min-w-10 rounded-xl border border-ink-200/70 bg-white/80 text-ink-700 shadow-sm dark:border-ink-700/60 dark:bg-ink-800/80 dark:text-ink-100"
      {...props}
      ref={ref}
    >
      <Terminal className="h-5 w-5" />
    </Component>
  )
}) as Polymorphic<'span'>
